import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
  DialogClose,
} from "./dialog";
import { Button } from "./button";

interface WarningDialogProps {
  open: boolean;
  title?: string;
  message?: React.ReactNode;
  onClose: () => void;
}

const WarningDialog: React.FC<WarningDialogProps> = ({
  open,
  title = "Warning",
  message,
  onClose,
}) => {
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md bg-white border">
        <DialogHeader>
          <DialogTitle className="text-lg font-semibold text-amber-700">
            {title}
          </DialogTitle>
          {message && (
            <DialogDescription className="mt-2 text-sm text-gray-700">
              {message}
            </DialogDescription>
          )}
        </DialogHeader>

        <DialogFooter>
          <Button variant="outline" onClick={onClose} className="mr-2">
            Close
          </Button>
        </DialogFooter>

        <DialogClose />
      </DialogContent>
    </Dialog>
  );
};

export default WarningDialog;
